import axios from 'axios'
import shortly from 'vuex-shortly'
import { PERMISSIONS } from '@store/types'

const state = {
  permissions: []
}

const getters = {
  [PERMISSIONS]: 'permissions'
}

const mutations = {
  [PERMISSIONS]: 'permissions'
}

const actions = {
  [PERMISSIONS]: async ({ commit }) => {
    const response = await axios.get('/permission')
    commit(PERMISSIONS, response.data?.data)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/permissions.js